import { useEffect, useState } from 'react'
import { sessionManager } from '@/utils/sessionManager'
import Modal from '../Modal/Modal'
import Button from '../Button/Button'
import axios from '@/utils/axiosInterceptor'

import styles from './SessionTimeout.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export function SessionTimeout() {
    const [showWarning, setShowWarning] = useState(false)
    const [timeRemaining, setTimeRemaining] = useState(null)

    useEffect(() => {
        const interval = setInterval(() => {
            if (sessionManager.shouldWarn()) {
                setShowWarning(true)
                setTimeRemaining(Math.floor(sessionManager.getTimeRemaining() / 1000))
            } else if (sessionManager.isExpired()) {
                setShowWarning(false)
                setTimeRemaining(null)

                sessionManager.clear()
                window.location.href = '/login?expired=true'
            } else {
                setTimeRemaining(null)
                setShowWarning(false)
            }
        }, 1000) // Check every second
        return () => clearInterval(interval)
    }, [])

    return (
        <Modal open={showWarning} setOpen={setShowWarning} allowClose={false}>
            <div className={classes('container')}>
                {timeRemaining !== null && timeRemaining >= 0 && (
                    <IdleTimerContent timeRemaining={timeRemaining} setShowWarning={setShowWarning} />
                )}
            </div>
        </Modal>
    )
}

const IdleTimerContent = ({ timeRemaining, setShowWarning }) => {
    return (
        <>
            <h3 className={classes('title')}>Are you still there?</h3>
            <p className={classes('description')}>You will automatically be logged out in:</p>
            <div className={classes('countdown')}>
                {Math.floor(timeRemaining / 60)}:{String(timeRemaining % 60).padStart(2, '0')}
            </div>
            <p className={classes('description')}>
                At Taxd we take your security seriously. For your protection, we will log you out after a period of
                inactivity.
            </p>
            <p className={classes('description')}>
                This is to ensure that no one else can access your account if you leave your device unattended.
            </p>
            <p className={classes('description')}>
                If you wish to continue your session, please click "Stay Logged In" below.
            </p>
            <div className={classes('button-wrapper')}>
                <Button
                    onClick={() => {
                        sessionManager.clear()
                        window.location.href = '/login'
                    }}
                    type="white-gray"
                    text="Log out"
                />
                <Button
                    onClick={async () => {
                        try {
                            await axios.post('/assessment/api/ping')
                            setShowWarning(false)
                        } catch (e) {
                            alert('An issue occurred, please log in again.')
                            sessionManager.clear()
                            window.location.href = '/login'
                        }
                    }}
                    type="primary"
                    text="Stay Logged In"
                />
            </div>
        </>
    )
}

export const TimedOutContent = () => {
    const [showTimeoutModal, setShowTimeoutModal] = useState(false)

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('expired') === 'true') {
            setShowTimeoutModal(true)
        }
    }, [])

    return (
        <>
            <Modal open={showTimeoutModal} setOpen={() => {}} allowClose={false}>
                <div className={classes('container')}>
                    <h3 className={classes('title')}>Your session has expired</h3>
                    <p className={classes('description')}>
                        For your security, you have been logged out due to inactivity. Please log in again to continue
                        using the application.
                    </p>
                    <div className={classes('button-wrapper')}>
                        <div></div>
                        <Button
                            onClick={() => {
                                setShowTimeoutModal(false)
                            }}
                            type="primary"
                            text="Continue"
                        />
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default SessionTimeout
